var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-auth"},[_c('Error',_vm._g(_vm._b({staticStyle:{"margin-top":"0"},attrs:{"title":_vm.$t('com_error_forbidden'),"description":_vm.$t('com_error_forbidden_description'),"homePrimary":"primary","homeClick":_vm.homeClick}},'Error',_vm.$attrs,false),_vm.$listeners),[_c('Icon',{attrs:{"type":"forbidden"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }